import { render } from "./BalLink.vue?vue&type=template&id=aceddf56"
import script from "./BalLink.vue?vue&type=script&lang=js"
export * from "./BalLink.vue?vue&type=script&lang=js"
script.render = render

export default script